import { useSelector } from "react-redux";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { Divider2 } from "@/ui2/atoms/Divider";
import type { NoteDetail } from "@/core/types";
import type { RootState } from "@/lib/types/state";
import { Spinner2 } from "@/ui2/atoms/Spinner";

import { NoteContentRouter } from "./NoteContentRouter";
import { SignatureList } from "./(signature)/components/SignatureList";

import "./BaseNoteLayout.print.styles.scss";

type BaseNoteLayoutProps = {
  isEditing: boolean;
  note: NoteDetail;
  patientName: string | undefined;
  refetchNote: () => void;
  setIsEditing: (v: boolean) => void;
};

export function BaseNoteLayout({
  isEditing,
  note,
  patientName,
  refetchNote,
  setIsEditing,
}: BaseNoteLayoutProps) {
  const profileName = useSelector<RootState, string | null | undefined>(
    (state) => state.auth.profile?.name,
  );

  if (!note) return <Spinner2 className="tw:mx-auto tw:mt-30" />;

  return (
    <DashboardCard2
      as="article"
      className="tw:flex tw:flex-col tw:gap-6"
      classNameHeader="tw:mb-0!"
      rawChildren
      title={note.title}
    >
      <NoteContentRouter
        isEditing={isEditing}
        note={note}
        patientName={patientName}
        profileName={profileName}
        refetchNote={refetchNote}
        setIsEditing={setIsEditing}
      />

      {!isEditing && (
        <>
          <Divider2 />
          <SignatureList note={note} />
        </>
      )}
    </DashboardCard2>
  );
}
